import React from 'react';
import styled from 'styled-components';
import { typeHelpers } from '@polymathnetwork/new-shared';
import { Button } from '~/components/Button';
import { RouterLink as RouterLinkComponent } from '~/components/RouterLink';

export type ButtonProps = typeHelpers.GetProps<typeof Button>;

export interface Props extends typeHelpers.Omit<ButtonProps, 'onClick'> {
  RouterLink?: React.ComponentType<any>;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const ButtonLinkBase = styled(
  ({ RouterLink, onClick, ...otherProps }: Props) => {
    const LinkComponent = RouterLink || RouterLinkComponent;
    return (
      <Button
        as={(props: ButtonProps) => {
          const { variant, iconPosition, ...filteredProps } = props;
          return <LinkComponent {...filteredProps} onClick={onClick} />;
        }}
        {...otherProps}
      />
    );
  }
)``;

export const ButtonLink = Object.assign(ButtonLinkBase, {
  defaultProps: Button.defaultProps,
});
try {
    // @ts-ignore
    ButtonLinkBase.displayName = "ButtonLinkBase";
    // @ts-ignore
    ButtonLinkBase.__docgenInfo = { "description": "", "displayName": "ButtonLinkBase", "props": { "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": false, "type": { "name": "(event: any) => void" } }, "RouterLink": { "defaultValue": null, "description": "", "name": "RouterLink", "required": false, "type": { "name": "any" } }, "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/ButtonLink/ButtonLink.tsx#ButtonLinkBase"] = { docgenInfo: ButtonLinkBase.__docgenInfo, name: "ButtonLinkBase", path: "src/components/ButtonLink/ButtonLink.tsx#ButtonLinkBase" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    ButtonLink.displayName = "ButtonLink";
    // @ts-ignore
    ButtonLink.__docgenInfo = { "description": "", "displayName": "ButtonLink", "props": { "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": false, "type": { "name": "(event: any) => void" } }, "RouterLink": { "defaultValue": null, "description": "", "name": "RouterLink", "required": false, "type": { "name": "any" } }, "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/ButtonLink/ButtonLink.tsx#ButtonLink"] = { docgenInfo: ButtonLink.__docgenInfo, name: "ButtonLink", path: "src/components/ButtonLink/ButtonLink.tsx#ButtonLink" };
}
catch (__react_docgen_typescript_loader_error) { }